import routeModel from './route';

export default routeModel;
